var React = require('react');

function Carat (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".line{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:0.5px;}")),React.createElement("polyline",{"className":"line","points":"16.18 8.35 8.18 0.35 0.18 8.35","key":1})]);
}

Carat.defaultProps = {"id":"content","viewBox":"0 0 16.35 8.53"};

module.exports = Carat;

Carat.default = Carat;
